import {RootStore} from "./rootStore";
import {action, observable, computed, makeObservable, runInAction} from "mobx";
import { IYear } from "../models/year";

export default class YearsStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeObservable(this, {
      years: observable,
      chosenYears: observable,
      yearClickedOpen: observable,
      getAllChosenSubjects: action,
      addChosenYear: action,
      removeChosenYear: action,
      allChosenYears: computed,
      clearChosenYears: action,
      setYearClickedOpen: action

    });
  }

  years:IYear[] = [];
  chosenYears:IYear[] = [];

  yearClickedOpen:IYear|null = null;

  setYears = (yearData:IYear[]) => {
    let sortOrder = 1;
    yearData.forEach(element => {
      element.sortOrder = sortOrder++;
    });
    runInAction(() => {
      this.years = yearData;
    })
  }


  getAllChosenSubjects = () => {
    if(this.chosenYears.length === 0) {
      return this.years;
    }
    return this.chosenYears;
  }

  addChosenYear = (year:IYear) => {
    this.chosenYears.push(year);
    this.chosenYears.sort((a,b) => a.sortOrder > b.sortOrder ? 1 : -1);
  }
  removeChosenYear = (year:IYear) => {
    this.chosenYears = this.chosenYears.filter((x => x.slug !== year.slug));
  }
  clearChosenYears = () => {
    this.chosenYears = [];
  }

  setYearClickedOpen = (openYear: IYear) => {
    this.yearClickedOpen = openYear;
  }

  get allChosenYears():IYear[] {
    if(this.rootStore.wallSettingsStore.subjectType === 'specialistModule') {
      if(this.chosenYears.length === 0) return this.years.filter(year => year.slug === 'fvi').slice();
      return this.chosenYears.filter(year => year.slug === 'fvi').slice();
    }
    if(this.chosenYears.length === 0) return this.years.slice();
    return this.chosenYears.slice();
  }

  get allYearsByType():IYear[] {
    if(this.rootStore.wallSettingsStore.subjectType === 'specialistModule') {
      return this.years.filter(year => year.slug === 'fvi');
    } else {
      // Otherwise just return year six
      return this.years;
    }
  }


}